import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injectable } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CircleTimerModule } from './modules/circle-timer/src/public-api';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignInComponent } from './component/sign-in/sign-in.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RangePipe } from './pipe/range-pipe/range.pipe';
import { FilterPipe } from './pipe/list-filter-pipe/list-filter-pipe';
import { FilterByKeyPipe } from './pipe/list-filterbykey-pipe/list-filterbykey-pipe';
import { AgmCoreModule } from '@agm/core';
import { TokenInterceptorService } from './service/token-interceptor-service/token-interceptor.service';
import { EditUserProfileComponent } from './component/user profile/edit-user-profile/edit-user-profile.component';
import { AuthorizationGuard } from './service/auth-guard/authorization-guard.service';
import { AutocompleteComponent } from './component/common-components/goolge-places-selecters/google-places.component';
import { RolePipe } from './pipe/role-value-filter/role.pipe';
import { AccountStatusPipe } from './pipe/account-status-value-filter/account-status.pipe';
import { ImageModalComponent } from './modal/image-modal/image-modal.component';
import { CamelCasePipe } from './pipe/camelcase.filter/camelcase.filter.pipe';
import { UrlSafePipe } from './pipe/url-safe-pipe/url-safe.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { UnassignedComponent } from './component/assigned-trips/unassigned/unassigned.component';
import { NewTripComponent } from './component/assigned-trips/new-trip/new-trip.component';
import { GooglePlaceDirective } from './directives/google-places-directive/google-place.directive';
import { HourPipePipe } from './pipe/hour-range-pipe/hour-pipe.pipe';
import { MinPipePipe } from './pipe/minute-range-pipe/min-pipe.pipe';
import { SocketIoModule, SocketIoConfig, Socket } from 'ngx-socket-io';
import { urls } from './utils/url-utils';
import { SocketService } from './service/socket-service/socket-service.service';
import { AgmOverlays } from 'agm-overlays';
import { TripFilterPipe } from './pipe/trip-list-filter-pipe/trip-filter.pipe';
import { TimeFormatDirective } from './directives/time-format-directive/time-format.directive';
import { TimePipe } from './pipe/time-pipe/time.pipe';
import { AgmDirectionModule } from 'agm-direction';
import { TripDetailDialogComponent } from './component/common-components/trip-detail-dialog/trip-detail-dialog.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { CommonAlertComponent } from './component/common-components/common-alert/common-alert.component';
import { TimeagoModule } from 'ngx-timeago';
import { MySocketWrapper } from './service/socket-service/socket-wrapper';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule } from './modules/ngx-ui-loader/src/public-api';
import { DatePipe } from './pipe/date-pipe/date.pipe';
import { OwlModule } from 'ngx-owl-carousel';
import { TodayTripsPipe } from './pipe/today-trips-pipe/today-trips.pipe';
import { NotificationDetailsComponent } from './notification/notification-details/notification-details.component';
import { MemberListComponent } from './component/members/member-list/member-list.component';
import { CreateMemberComponent } from './component/members/create-member/create-member.component';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation/click-stop-propagation.directive';
import { TripDetailModelComponent } from './component/assigned-trips/trip-detail-model/trip-detail-model.component';
import { ZDatesComponent } from './component/z-dates/z-dates.component';
import { SideNavComponent } from './component/shared/layout/side-nav/side-nav.component';
import { HeaderComponent } from './component/shared/layout/header/header.component';
import { NotificationsSlideoutComponent } from './component/shared/slideouts/notifications-slideout/notifications-slideout.component';
import { SortByDatePipe } from './pipe/sort-by-date.pipe';
import { OutsideClickDirective } from './directives/outside-click-directive/outside-click.directive';
import { ClockTimePipe } from './pipe/clock-time/clock-time.pipe';
import { EditTripModalComponent } from './component/assigned-trips/edit-trip-modal/edit-trip-modal.component';
import { ToastrModule } from 'ngx-toastr';
import { AuthTokenComponent } from './component/auth-token/auth-token.component';

import { AddressPickerComponent } from './component/shared/address-picker/address-picker.component';

import { ImagesliderDirective } from './directives/image-slider/imageslider.directive';
import { SortByPipe } from './pipe/sortby-filter-pipe/sortby-filter-pipe';
import { PoisitiveNumberDirective } from './directives/positive-number/poisitive-number.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConvertPhoneNumberDirective } from './directives/number-directive/convert-phone-number.directive';
import { StandingOrdersV2Component } from './component/assigned-trips/standing-orders-v2/standing-orders-v2.component';
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule } from './modules/picker/src/public_api';
import { OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS } from './modules/picker/src/lib/date-time/adapter/moment-adapter/moment-date-time-adapter.class';
import { OwlMomentDateTimeModule } from './modules/picker/src/lib/date-time/adapter/moment-adapter/moment-date-time.module';
import { TimezonePickerModule } from './modules/ng2-timezone-selector/src';
import { UnAuthorizationGuard } from './service/non-auth-guard/unauthorization-guard.service';
import { StandingorderDetailModalComponent } from './component/assigned-trips/standingorder-detail-modal/standingorder-detail-modal.component';
import { NumericSortPipe } from './pipe/numeric-sort-pipe/numeric-sort.pipe';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FormatTitleCasePipe } from './pipe/format-titlecase.filter/format-titlecase.filter.pipe';
import { SortByNumberPipe } from './pipe/sortby-number/sort-by-number.pipe';
import { PopperDirective } from './directives/popper-tooltip/popper.directive';
import { NumberDirective } from './directives/number-only-directive/number-only-directive';
import { AddMemberWrapperModalComponent } from './component/members/add-member-wrapper-modal/add-member-wrapper-modal.component';
import { ArrayFilterbykeyPipePipe } from './pipe/array-filterbykey-pipe/array-filterbykey-pipe.pipe';
import { TripActivityLogComponent } from './component/assigned-trips/trip-activity-log/trip-activity-log.component';
import { environment } from 'src/environments/environment';
import { StaffListComponent } from './component/staffs/staff-list/staff-list.component';
import { AddStaffComponent } from './component/staffs/add-staff/add-staff.component';
import { TripDetailsComponent } from './component/assigned-trips/trip-details/trip-details.component';
import { CompanyNoteModalComponent } from './component/assigned-trips/company-note-modal/company-note-modal.component';
import { StandingOrderCloneModalComponent } from './component/assigned-trips/standing-order-clone-modal/standing-order-clone-modal.component';
import { CancelTripModalComponent } from './modal/cancel-trip-modal/cancel-trip-modal.component';
import { OperationsComponent } from './component/assigned-trips/operations/operations.component';
import { GanttChartComponent } from './component/assigned-trips/gantt-chart/gantt-chart.component';
import { TooltipDirective } from './directives/tooltip/tooltip.directive';
import { TooltipComponent } from './component/shared/tooltip/tooltip.component';
import { WillCallModalComponent } from './modal/will-call-modal/will-call-modal.component';
import { TripActionsDropdownComponent } from './component/shared/trip-actions-dropdown/trip-actions-dropdown.component';
import { TripReportsComponent } from './component/reports/trip-reports/trip-reports.component';
import { OtpListComponent } from './component/otp/otp-list/otp-list.component';
import { OtpDetailModelComponent } from './component/otp-detail-model/otp-detail-model.component';
import { NotesModalComponent } from './modal/notes-modal/notes-modal.component';
import { MemberDetailModalComponent } from './modal/member-detail-modal/member-detail-modal.component';
import { GanttChartV2Component } from './component/assigned-trips/gantt-chart-v2/gantt-chart-v2.component';
import { ViolationBadgeDirective } from './directives/violation-badge/violation-badge.directive';
import { PublicOperationsComponent } from './component/assigned-trips/public-operation/public-operations/public-operations.component';
import { PublicOperationHandshakeComponent } from './component/assigned-trips/public-operation/public-operation-handshake/public-operation-handshake.component';
import { ForgotPasswordComponent } from './component/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { TwoFactorAuthenticationComponent } from './component/two-factor-authentication/two-factor-authentication.component';
import { TwoFactorAuthenticationGuard } from './service/two-factor-guard/two-factor-guard.service';
import { FacilityComponent } from './component/facility/facility.component';
import { PossibilityAssignModalComponent } from './modal/possibility-assign-modal/possibility-assign-modal.component';
import { PatientComponent } from './component/placement/patient/patient.component';
import { ReservationsComponent } from './component/placement/reservations/reservations.component';
import { CreateAssistComponent } from './component/placement/assist/create-assist/create-assist.component';
import { AssistListComponent } from './component/placement/assist/assist-list/assist-list.component';
import { AddPatientComponent } from './component/placement/add-patient/add-patient.component';
import { ReservationDetailModalComponent } from './component/placement/reservation-detail-modal/reservation-detail-modal.component';
import { AssistDetailModalComponent } from './component/placement/assist/assist-detail-modal/assist-detail-modal.component';
import { ProposalDetailModalComponent } from './component/placement/proposal/proposal-detail-modal/proposal-detail-modal.component';
import { FacilityDetailModalComponent } from './component/placement/facility/facility-detail-modal/facility-detail-modal.component';
import { FacilityRatingModalComponent } from './component/placement/facility/facility-rating-modal/facility-rating-modal.component';
import { MessagesComponent } from './component/placement/messages/messages.component';


const ngxUiLoaderConfig: NgxUiLoaderConfig  = {
  bgsColor: 'red',
  bgsOpacity: 0.5,
  bgsPosition: 'bottom-right',
  bgsSize: 80,
  bgsType: 'ball-spin-clockwise',
  blur: 0,
  fgsColor: '#727cf5',
  fgsPosition: 'center-center',
  fgsSize: 0,
  fgsType: 'ball-spin',
  gap: 24,
  logoPosition: 'center-center',
  logoSize: 150,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: '#ffffff',
  pbColor: '#727cf5',
  pbDirection: 'ltr',
  pbThickness: 3,
  hasProgressBar: true,
  text: '',
  textColor: '#FFFFFF',
  textPosition: 'center-center',
};

export const MY_MOMENT_FORMATS = {
  fullPickerInput: 'MM/DD/YYYY HHmm',
  parseInput: 'l LT',
  datePickerInput: 'l',
  timePickerInput: 'HH:mm',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  swipeEasing: true,
  minScrollbarLength: 20
};

// setup map key on base of day
let mapKey =  'AIzaSyDEBvsqoGN0Kd-g71IQ7qgWvTogvyyFOUk';
const prodKeys = [
  'AIzaSyDEBvsqoGN0Kd-g71IQ7qgWvTogvyyFOUk', // 0
  'AIzaSyDEBvsqoGN0Kd-g71IQ7qgWvTogvyyFOUk', // 1
  'AIzaSyDEBvsqoGN0Kd-g71IQ7qgWvTogvyyFOUk', // 2
  'AIzaSyDEBvsqoGN0Kd-g71IQ7qgWvTogvyyFOUk', // 3
  'AIzaSyDEBvsqoGN0Kd-g71IQ7qgWvTogvyyFOUk', // 4
  'AIzaSyDEBvsqoGN0Kd-g71IQ7qgWvTogvyyFOUk', // 5
  'AIzaSyDEBvsqoGN0Kd-g71IQ7qgWvTogvyyFOUk'  // 6
];

if (environment.production) {
  const today = new Date();
  const day = today.getDay(); // 0 - 6
  mapKey = prodKeys[day];
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SignInComponent,
    RangePipe,
    FilterPipe,
    FilterByKeyPipe,
    EditUserProfileComponent,
    AutocompleteComponent,
    RolePipe,
    AccountStatusPipe,
    ImageModalComponent,
    CamelCasePipe,
    UrlSafePipe,
    NewTripComponent,
    AutocompleteComponent,
    UnassignedComponent,
    GooglePlaceDirective,
    HourPipePipe,
    MinPipePipe,
    TripFilterPipe,
    TimeFormatDirective,
    TimePipe,
    TripDetailDialogComponent,
    CommonAlertComponent,
    DatePipe,
    TodayTripsPipe,
    NotificationDetailsComponent,
    MemberListComponent,
    CreateMemberComponent,
    ClickStopPropagationDirective,
    TripDetailModelComponent,
    ZDatesComponent,
    SideNavComponent,
    NotificationsSlideoutComponent,
    SortByDatePipe,
    FormatTitleCasePipe,
    OutsideClickDirective,
    ClockTimePipe,
    SortByPipe,
    EditTripModalComponent,
    AuthTokenComponent,
    AddressPickerComponent,
    ImagesliderDirective,
    PoisitiveNumberDirective,
    ConvertPhoneNumberDirective,
    StandingOrdersV2Component,
    StandingorderDetailModalComponent,
    NumericSortPipe,
    SortByNumberPipe,
    PopperDirective,
    NumberDirective,
    AddMemberWrapperModalComponent,
    ArrayFilterbykeyPipePipe,
    TripActivityLogComponent,
    StaffListComponent,
    AddStaffComponent,
    TripDetailsComponent,
    CompanyNoteModalComponent,
    StandingOrderCloneModalComponent,
    CancelTripModalComponent,
    OperationsComponent,
    GanttChartComponent,
    TooltipDirective,
    TooltipComponent,
    WillCallModalComponent,
    TripActionsDropdownComponent,
    TripReportsComponent,
    OtpListComponent,
    OtpDetailModelComponent,
    NotesModalComponent,
    MemberDetailModalComponent,
    GanttChartV2Component,
    ViolationBadgeDirective,
    PublicOperationsComponent,
    PublicOperationHandshakeComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    TwoFactorAuthenticationComponent,
    FacilityComponent,
    PossibilityAssignModalComponent,
    PatientComponent,
    ReservationsComponent,
    CreateAssistComponent,
    AssistListComponent,
    AddPatientComponent,
    ReservationDetailModalComponent,
    AssistDetailModalComponent,
    ProposalDetailModalComponent,
    FacilityDetailModalComponent,
    FacilityRatingModalComponent,
    MessagesComponent
    ],
  entryComponents: [TooltipComponent],


  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SignaturePadModule,
    ReactiveFormsModule,
    TimeagoModule.forRoot(),
    HttpClientModule, // import HttpClientModule
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig), // import NgxUiLoaderModule
    NgxUiLoaderHttpModule.forRoot({ exclude:['http://provider.qalbs.com/api/assigns/dashboard', 'http://provider.qalbs.com/api/notifications', 'http://provider.qalbs.com/api/assigns/corporate',
    'http://provider.qalbs.com/api/users/me',  'http://provider.qalbs.com/api/drivers/nearby'],
     showForeground: true }),
     CircleTimerModule,
    AgmCoreModule.forRoot({
      apiKey: mapKey,
      libraries: ['places']
    }),
    SocketIoModule,
    TimezonePickerModule,
    AgmDirectionModule,
    BrowserAnimationsModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    PerfectScrollbarModule,
    AgmOverlays,
    OwlModule,
    ToastrModule.forRoot({
    timeOut: 3000,
    positionClass: 'toast-bottom-left',
    preventDuplicates: true,
    progressBar:true
    }),
    NgSelectModule,
    NgMultiSelectDropDownModule.forRoot()
  ],

  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    { provide: AuthorizationGuard, useClass: AuthorizationGuard },
     { provide: TwoFactorAuthenticationGuard, useClass: TwoFactorAuthenticationGuard },
   { provide: UnAuthorizationGuard, useClass: UnAuthorizationGuard },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
    { provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    DatePipe,
    FormatTitleCasePipe,
    MySocketWrapper,
    SocketService,
    CamelCasePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
